import { AnimatePresence, motion } from "framer-motion";
import { Lock } from "lucide-react";
import { Logo } from "@/components/Brand";

export function ProcessingScreen({ open, amount }) {
  return (
    <AnimatePresence>
      {open && (
        <motion.div data-testid="processing-screen" className="fixed inset-0 z-[70] bg-white text-[#111827] flex flex-col items-center justify-center" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
          <Logo />
          <div className="mt-10 w-14 h-14 rounded-full border-4 border-gray-200 border-t-[#00A3FF] animate-spin" />
          <h2 className="mt-8 font-display text-2xl font-bold">Processing your payment</h2>
          <p className="mt-2 text-gray-500 text-sm">${amount} · Please don't close or refresh this page.</p>
          <div className="mt-10 flex items-center gap-2 text-xs text-gray-400"><Lock size={13} />256-bit SSL encrypted</div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
